import { BigNumber } from '@xylabs/bignumber'

import { XyoWorldMinterWrapper } from '../../../EthersClients'
import { Quadkey } from '../../../Quadkey'

export class Actions {
  private minter: XyoWorldMinterWrapper

  private quadkey: Quadkey

  constructor(quadkey: Quadkey, minter: XyoWorldMinterWrapper) {
    this.minter = minter
    this.quadkey = quadkey
  }

  public async bid(amount: BigNumber) {
    return await this.minter.bid(this.quadkey, amount)
  }

  public async mint() {
    return await this.minter.mint(this.quadkey)
  }

  public async mintForReward() {
    return await this.minter.mintForReward(this.quadkey)
  }
}
